import React from 'react';
import { useEppoExpEnabled, useUser } from '@reverbdotcom/commons/src/user_hooks';
import eppoFlags from '@reverbdotcom/commons/src/eppoFlags';
import { EppoSubjectTypes } from '@reverbdotcom/commons/src/eppo/eppoExperimentHelpers';
import NotificationsCenterPopover from './notifications_center_popover';

interface IProps {
  children: JSX.Element;
}

export default function NotificationsCenterExperiment({ children }: IProps) {
  const user = useUser();

  if (user.loggedOut || !user.id) {
    return children;
  }

  return <SignedInNotificationsCenterExperiment>{children}</SignedInNotificationsCenterExperiment>;
}

function SignedInNotificationsCenterExperiment({ children }: IProps) {
  const user = useUser();
  const inTreatment = useEppoExpEnabled({
    flagKey: eppoFlags.NOTIFICATIONS_CENTER,
    subjectKey: user.id,
    subjectType: EppoSubjectTypes.USER_ID,
  });

  return inTreatment ? <NotificationsCenterPopover /> : children;
}
